import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/pages/Home.vue";
// import AboutUs from "@/pages/aboutUs"

Vue.use(VueRouter);

const routes = [
  {
    path: "/products",
    name: "Home",
    component: Home,
    redirect: '/products/productsCenter',
    children: [
      {
        path: 'productsCenter',
        name:'Products',
        component: () => import('@/pages/products'),
      },
      {
        path: 'productsCenter/mcuInterface',
        name:'McuInterface',
        component: () => import('@/pages/products/modules/mcuInterface'),
      },
      {
        path: 'productsCenter/otherChip',
        name:'OtherChip',
        component: () => import('@/pages/products/modules/otherChip'),
      },
      {
        path: 'productsCenter/hotProducts',
        name:'HotProducts',
        component: () => import('@/pages/products/modules/hotProducts'),
      },
      // {
      //   path: ':productName',
      //   name:'QingKe',
      //   component: () => import('@/pages/products/modules/QingKe'),
      // },
      {
        path: 'QingKe.html',
        name:'QingKe',
        component: () => import('@/pages/products/modules/QingKe'),
      },
      {
        path: ':productName',
        name:'ChipDetail',
        component: () => import('@/pages/products/modules/chipDetail'),
      },
      {
        path: '*',
        name:'404',
        component: () => import('@/pages/products'),
      },
    ]
  },
  //关于我们（多个路由地址对应同个组件）
  // {
  //   path: '/',
  //   name:'AboutUs',
  //   component: AboutUs,
  //   redirect: '/about_us',
  //   children: [
  //     {
  //       path: 'about_us.html',
  //       name:'AboutUs',
  //       component: () => import('@/pages/aboutUs/modules/company'),
  //     },
  //     {
  //       path: 'news.html',
  //       name:'News',
  //       component: () => import('@/pages/aboutUs/modules/company'),
  //     },
  //     {
  //       path: 'news/:id.html',
  //       name:'NewItem',
  //       component: () => import('@/pages/aboutUs/modules/company'),
  //     },
  //     {
  //       path: 'certification.html',
  //       name:'Certification',
  //       component: () => import('@/pages/aboutUs/modules/company'),
  //     },
  //     {
  //       path: 'statement.html',
  //       name:'Statement',
  //       component: () => import('@/pages/aboutUs/modules/company'),
  //     },
  //   ],
  // },
];

//原
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


const router = new VueRouter({
  routes,
  // base: '/',
  mode:'history',
});

export default router;
